import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  [key: string]: {
    status?: ReduxStateType;
    data?: any[];
    totalRecords?: number;
  };
}

const initialState: InitialState = {};

const getVoteResultSlice = createSlice({
  name: "getVoteResult",
  initialState,
  reducers: {
    getVoteResultStart: (
      state,
      action: PayloadAction<{
        id: string;
        awardId: string;
        sort: string;
        limit?: string | number;
        offset?: string | number;
      }>
    ) => {
      const data = state[action.payload.id]?.data ?? [];
      state[action.payload.id] = {
        status: ReduxStateType.LOADING,
        data,
        totalRecords: 0,
      };
    },
    getVoteResultSuccess: (
      state,
      action: PayloadAction<{
        id: string;
        data: any[];
        totalRecords: number;
      }>
    ) => {
      state[action.payload.id] = {
        status: ReduxStateType.SUCCESS,
        data: [...state[action.payload.id].data, ...action.payload.data],
        totalRecords: action.payload.totalRecords,
      };
    },
    getVoteResultFailed: (state, action: PayloadAction<{ id: string }>) => {
      state[action.payload.id] = {
        status: ReduxStateType.ERROR,
        data: [],
      };
    },
    resetVoteResult: (state, action: PayloadAction<{ id: string }>) => {
      state[action.payload.id] = {};
    },
  },
});

export const {
  getVoteResultStart,
  getVoteResultSuccess,
  getVoteResultFailed,
  resetVoteResult,
} = getVoteResultSlice.actions;

export default getVoteResultSlice.reducer;
